export const DISCOUNT_SERVICE_ENDPOINT = {
  COUPONS: '/coupons',
  COUPON: '/coupon',
  MASTER_DATA: '/master-data'
};
